import styles from "./Header.module.scss"

interface HeaderProps {
  text: string | JSX.Element
}

const Header: React.FC<HeaderProps> = ({ text }) => <div className={styles.header}>{text}</div>

export default Header
